import deepmerge from 'deepmerge';
import { fade } from '@/uptk/core/packages/style/color_utils';

const createPalette = ({
  type,
  blue30,
  blue500,
  grey20,
  grey600,
  grey800,
  white
}: any) => {
  if (type == 'light') {
    return {
      color1: white,
      color2: blue30,
      color3: blue500,
      color4: grey20
    }
  }
  return {
    color1: grey800,
    color2: fade(blue500, 0.4),
    color3: blue500,
    color4: grey600
  };
};

const createRegular = ({
  color1,
  color2,
  color3,
  color4
}: any) => ({
  default: {
    background: color1,
    textAlign: 'left'
  },
  active: {
    background: color3,
    color: color1
  },
  hover: {
    background: color2
  },
  disabled: {
    background: color4,
    opacity: 0.4
  },
  selected: {
    background: color3
  },
  readOnly: {
    background: color1
  }
});

const createRegularDensity = (density: any, theme: any) => {
  const { iconography, typography } = theme;
  const {
    iconSelected: { color: iconSelectedColor }
  } = iconography;
  const getTypography = typography;
  const { color: paragraph } = getTypography({ variant: 'paragraph', density });
  const { color: selected } = getTypography({
    variant: 'selected',
    density
  });
  return {
    default: {
      foreground: paragraph,
      icon: paragraph
    },
    hover: {
      foreground: paragraph,
      icon: paragraph
    },
    active: {
      foreground: selected,
      icon: iconSelectedColor
    },
    selected: {
      foreground: selected,
      icon: iconSelectedColor
    }
  }
};

const createGetSelectable = (options: any) => ({
                                          variant = 'regular',
                                          density = 'medium',
                                          state = 'default'
                                        } = {}) => {
  const { hasOwnProperty } = Object.prototype;
  if (!hasOwnProperty.call(options, variant)) {
    return undefined;
  }
  const variantByDensity = hasOwnProperty.call(options[variant], density)
      ? options[variant][density]
      : {};
  if (state) {
    return variantByDensity[state] || {};
  }
  return variantByDensity;
};

export const createSelectable = (palettes: any, selectable = {}) => {
  const { getSelectable: otherGetSelectable, ...otherOptions }
      = typeof selectable == 'function' ? selectable(palettes) : selectable;
  const selectablePalette = createPalette(palettes.palette);
  const regularDefaults = createRegular(selectablePalette);
  const options = {
    regular: {
      touch: deepmerge(
          regularDefaults,
          createRegularDensity('touch', palettes)
      ),
      low: deepmerge(
          regularDefaults,
          createRegularDensity('low', palettes)
      ),
      medium: deepmerge(
          regularDefaults,
          createRegularDensity('medium', palettes)
      ),
      high: deepmerge(
          regularDefaults,
          createRegularDensity('high', palettes)
      )
    }
  };
  const mergedOptions = deepmerge(options, otherOptions, {
    clone: false
  });
  return {
    getSelectable: otherGetSelectable || createGetSelectable(mergedOptions),
    ...mergedOptions
  };
};
